import { Button } from '@/components/ui/button';
import { Skeleton } from '@/components/ui/skeleton';
import { AlertTriangle, RotateCcw } from 'lucide-react';

const getMessage = (error: unknown) => {
  if (error instanceof Error) return error.message;
  return 'Ekki tókst að sækja gögn.';
};

export const SectionError = ({
  title,
  error,
  onRetry,
}: {
  title: string;
  error: unknown;
  onRetry: () => void;
}) => (
  <div className="flex min-h-28 flex-col justify-center gap-3 rounded-md border border-destructive/30 p-4 text-sm">
    <div className="flex items-start gap-2 text-destructive">
      <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0" />
      <div>
        <p className="font-medium">{title}</p>
        <p className="text-muted-foreground">{getMessage(error)}</p>
      </div>
    </div>
    <Button type="button" variant="outline" size="sm" className="w-fit gap-2" onClick={onRetry}>
      <RotateCcw className="h-4 w-4" />
      Reyna aftur
    </Button>
  </div>
);

export const SectionLoading = ({ label = 'Sæki gögn' }: { label?: string }) => (
  <output className="block space-y-3" aria-label={label}>
    <Skeleton className="h-5 w-36" />
    <Skeleton className="h-8 w-full" />
    <Skeleton className="h-8 w-5/6" />
    <span className="sr-only">{label}</span>
  </output>
);
